import React from 'react'
import { Select, Switch } from 'antd'
import { TFunction } from 'next-i18next'
import { companySizes } from 'src/core/helpers/companies'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { CustomTextInput, CustomSelect, CountrySelector } from 'src/components'

interface CompanyDetailsSection {
  labels: {
    title: string,
    subtitle: string
  }
  component: React.FunctionComponent<any>,
  children?: React.ReactNode,
  xs1?: number
  xs2?: number,
  props: {
    name?: string
    required?: boolean
    onChange?: Function
    handleOnChange?: Function
    placeholder?: string
    checked?: boolean
    checkedChildren?: React.ReactNode,
    unCheckedChildren?: React.ReactNode
    disabled?: boolean
  }
}

export const companyDetailsSections = (
  t: TFunction,
  handleValidation: Function,
  isIntraCommunityOperator: boolean,
  handleIntraCommunityOperator: Function,
  isIntraCommunityDisabled: boolean
): CompanyDetailsSection[] => [

  { // Company name
    labels: {
      title: `${t('settings.CompanyName')} *`,
      subtitle: t('settings.NameLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'name',
      required: true,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'name'),
      placeholder: t('settings.NamePlaceHolder')
    }
  },

  { // Company Size
    labels: {
      title: t('settings.CompanySize'),
      subtitle: t('settings.SizeLabel')
    },
    component: CustomSelect,
    children: <>
      {companySizes.map((c, idx) => (
        <Select.Option
          value={c.value}
          key={idx}
        >
          {String(t(`settings.${c.label}`))}
        </Select.Option>
      ))}
    </>,
    props: {
      name: 'size',
      required: false,
      onChange: (v: string) => handleValidation(v, 'size'),
      placeholder: t('settings.CompanySize')
    }
  },

  { // Company VAT
    labels: {
      title: t('settings.VATNumber'),
      subtitle: t('settings.VatNumberLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'vat_number',
      required: false,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'vat_number'),
      placeholder: t('settings.VatNumberPlaceHolder')
    }
  },

  { // Company Fiscal ID
    labels: {
      title: t('settings.FiscalId'),
      subtitle: t('settings.FiscalIdLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'id_number',
      required: false,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'id_number'),
      placeholder: t('settings.FiscalIdPlaceHolder')
    }
  },

  { // Company Comunitity operator
    labels: {
      title: t('settings.IntraCommunityOperator'),
      subtitle: t('settings.IntraCommunityOperatorLabel')
    },
    component: Switch,
    xs1: 20,
    xs2: 4,
    props: {
      checked: isIntraCommunityOperator,
      onChange: (value: boolean) => {
        handleValidation(value, 'is_intracommunity_operator')
        handleIntraCommunityOperator(value)
      },
      disabled: isIntraCommunityDisabled,
      checkedChildren: <CheckOutlined />,
      unCheckedChildren: <CloseOutlined />
    }
  },

  { // Company Adress
    labels: {
      title: `${t('settings.Address')} *`,
      subtitle: t('settings.AddressLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'street',
      required: true,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'street'),
      placeholder: t('settings.AddressPlaceHolder')
    }
  },

  { // Company City
    labels: {
      title: `${t('settings.City')} *`,
      subtitle: t('settings.CityLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'city',
      required: true,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'city'),
      placeholder: t('settings.CityPlaceHolder')
    }
  },

  { // Company Postal Code
    labels: {
      title: `${t('settings.PostalCode')} *`,
      subtitle: t('settings.PostalCodeLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'postal_code',
      required: true,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'postal_code'),
      placeholder: t('settings.PostalCodePlaceHolder')
    }
  },

  { // Company Province
    labels: {
      title: `${t('settings.Province')} *`,
      subtitle: t('settings.ProvinceLabel')
    },
    component: CustomTextInput,
    props: {
      name: 'state',
      required: true,
      onChange: (v: React.ChangeEvent<HTMLInputElement>) => handleValidation(v, 'state'),
      placeholder: t('settings.ProvincePlaceHolder')
    }
  },

  { // Company Country
    labels: {
      title: `${t('settings.Country')} *`,
      subtitle: t('settings.ChoseCountry')
    },
    component: CountrySelector,
    props: {
      name: 'country',
      required: true,
      handleOnChange: (v: number) => handleValidation(v, 'country'),
      placeholder: t('settings.CompanyCountry')
    }
  },
]
